import { useEffect, useState } from 'react';

export type Viewport = 'mobile' | 'tablet' | 'desktop';

const MOBILE_MAX = 768;
const TABLET_MAX = 1100;

/** Pure helper exported for testing. */
export function classifyViewport(width: number): Viewport {
  if (width < MOBILE_MAX) return 'mobile';
  if (width < TABLET_MAX) return 'tablet';
  return 'desktop';
}

/**
 * Returns the current viewport bucket, recomputed on resize.
 * SSR-safe: defaults to "desktop" when window is unavailable.
 */
export function useViewport(): Viewport {
  const [viewport, setViewport] = useState<Viewport>(() =>
    typeof window === 'undefined' ? 'desktop' : classifyViewport(window.innerWidth),
  );

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const onResize = () => setViewport(classifyViewport(window.innerWidth));
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return viewport;
}

export const VIEWPORT_BREAKPOINTS = { MOBILE_MAX, TABLET_MAX } as const;
